import { FormState } from '@constants/commonApp/types';

import { SchoolDetailsTeacherFields, CertificationsFields } from './types';

export const updateCertificationsState = (certificationsFormState: FormState<CertificationsFields>) => {
  return {
    certifications: {
      ...certificationsFormState.data,
    },
  };
};

export const updateSchoolDetailsTeacherState = (
  schoolDetailsTeacherFormState: FormState<SchoolDetailsTeacherFields>,
) => {
  const {
    data: { academicRating },
  } = schoolDetailsTeacherFormState;

  return {
    academicRating,
  };
};
